// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: dom_hotel.proto

/* eslint-disable */
import { SearchSource, searchSourceFromJSON, searchSourceToJSON } from "./common_enum";
import { Timestamp } from "./google/protobuf/timestamp";
import { Location } from "./location";
import { RoomDom } from "./room_dom";

export const protobufPackage = "usertracking.v3";

export interface PriceEngineRules {
  id: number;
  title: string;
}

export interface DomHotel {
  date_from: string;
  date_to: string;
  city: string;
  city_id: number;
  hotel: string;
  hotel_id: number;
  ranking: number;
  rooms: RoomDom[];
  final_price: number;
  book_price: number;
  shop_random_id: string;
  booking_id: string;
  price_engine_rules: PriceEngineRules[];
  book_type: string;
  payment_gateway: string;
  amount: number;
  discount_code: string;
  error: string;
  discount: number;
  payment_success: boolean;
  is_non_instant: boolean;
  is_available: boolean;
  price_off: number;
  discount_percent: number;
  page: number;
  available_hotels_id: number[];
  available_rooms_id: number[];
  eligible_payment_gateways: string[];
  sent_date: Date | undefined;
  user_phone_number: string;
  submit_date: Date | undefined;
  count_of_photos: number;
  comment_entered: boolean;
  photo_included: boolean;
  usefulness_count: number;
  review_id: number;
  category_name: string;
  video_title: string;
  video_duration: number;
  video_watched_percentage: number;
  video_watched_duration: number;
  video_watched: number;
  number_of_video_interactions: number;
  total_interactions: number;
  number_of_interactions: number;
  count_of_videos: number;
  count_of_clicks_on_video: number;
  fully_watched: boolean;
  cta_type: string;
  redirected_link: string;
  last_minute_loaded: number;
  count_of_last_minute_cards: number;
  last_minute_card_clicked: number;
  blue_box_loaded: number;
  blue_box_card_clicked: number;
  from_last_minute: number;
  from_blue_box: number;
  count_of_blue_box_cards: number;
  gateway: string;
  search_source: SearchSource;
  timestamp: Date | undefined;
  basket_price: number;
  ycard_balance: number;
  penny_balance: number;
  user_location: Location | undefined;
  initial_zoom_level: number;
  listings_count: number;
  viewport_change_type: string;
  new_center_coords: Location | undefined;
  visible_listings_count: number;
  accommodation_id: number;
  position: number;
  click_area: string;
  stay_duration_days: number;
  removed_filter_name: string;
  current_map_center: Location | undefined;
  current_zoom_level: number;
  new_view_state: string;
  value: number;
}

function createBasePriceEngineRules(): PriceEngineRules {
  return { id: 0, title: "" };
}

export const PriceEngineRules: MessageFns<PriceEngineRules> = {
  fromJSON(object: any): PriceEngineRules {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
    };
  },

  toJSON(message: PriceEngineRules): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    return obj;
  },

  create(base?: DeepPartial<PriceEngineRules>): PriceEngineRules {
    return PriceEngineRules.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PriceEngineRules>): PriceEngineRules {
    const message = createBasePriceEngineRules();
    message.id = object.id ?? 0;
    message.title = object.title ?? "";
    return message;
  },
};

function createBaseDomHotel(): DomHotel {
  return {
    date_from: "",
    date_to: "",
    city: "",
    city_id: 0,
    hotel: "",
    hotel_id: 0,
    ranking: 0,
    rooms: [],
    final_price: 0,
    book_price: 0,
    shop_random_id: "",
    booking_id: "",
    price_engine_rules: [],
    book_type: "",
    payment_gateway: "",
    amount: 0,
    discount_code: "",
    error: "",
    discount: 0,
    payment_success: false,
    is_non_instant: false,
    is_available: false,
    price_off: 0,
    discount_percent: 0,
    page: 0,
    available_hotels_id: [],
    available_rooms_id: [],
    eligible_payment_gateways: [],
    sent_date: undefined,
    user_phone_number: "",
    submit_date: undefined,
    count_of_photos: 0,
    comment_entered: false,
    photo_included: false,
    usefulness_count: 0,
    review_id: 0,
    category_name: "",
    video_title: "",
    video_duration: 0,
    video_watched_percentage: 0,
    video_watched_duration: 0,
    video_watched: 0,
    number_of_video_interactions: 0,
    total_interactions: 0,
    number_of_interactions: 0,
    count_of_videos: 0,
    count_of_clicks_on_video: 0,
    fully_watched: false,
    cta_type: "",
    redirected_link: "",
    last_minute_loaded: 0,
    count_of_last_minute_cards: 0,
    last_minute_card_clicked: 0,
    blue_box_loaded: 0,
    blue_box_card_clicked: 0,
    from_last_minute: 0,
    from_blue_box: 0,
    count_of_blue_box_cards: 0,
    gateway: "",
    search_source: SearchSource.search_box,
    timestamp: undefined,
    basket_price: 0,
    ycard_balance: 0,
    penny_balance: 0,
    user_location: undefined,
    initial_zoom_level: 0,
    listings_count: 0,
    viewport_change_type: "",
    new_center_coords: undefined,
    visible_listings_count: 0,
    accommodation_id: 0,
    position: 0,
    click_area: "",
    stay_duration_days: 0,
    removed_filter_name: "",
    current_map_center: undefined,
    current_zoom_level: 0,
    new_view_state: "",
    value: 0,
  };
}

export const DomHotel: MessageFns<DomHotel> = {
  fromJSON(object: any): DomHotel {
    return {
      date_from: isSet(object.date_from) ? globalThis.String(object.date_from) : "",
      date_to: isSet(object.date_to) ? globalThis.String(object.date_to) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      city_id: isSet(object.city_id) ? globalThis.Number(object.city_id) : 0,
      hotel: isSet(object.hotel) ? globalThis.String(object.hotel) : "",
      hotel_id: isSet(object.hotel_id) ? globalThis.Number(object.hotel_id) : 0,
      ranking: isSet(object.ranking) ? globalThis.Number(object.ranking) : 0,
      rooms: globalThis.Array.isArray(object?.rooms) ? object.rooms.map((e: any) => RoomDom.fromJSON(e)) : [],
      final_price: isSet(object.final_price) ? globalThis.Number(object.final_price) : 0,
      book_price: isSet(object.book_price) ? globalThis.Number(object.book_price) : 0,
      shop_random_id: isSet(object.shop_random_id) ? globalThis.String(object.shop_random_id) : "",
      booking_id: isSet(object.booking_id) ? globalThis.String(object.booking_id) : "",
      price_engine_rules: globalThis.Array.isArray(object?.price_engine)
        ? object.price_engine.map((e: any) => PriceEngineRules.fromJSON(e))
        : [],
      book_type: isSet(object.book_type) ? globalThis.String(object.book_type) : "",
      payment_gateway: isSet(object.payment_gateway) ? globalThis.String(object.payment_gateway) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      discount_code: isSet(object.discount_code) ? globalThis.String(object.discount_code) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      discount: isSet(object.discount) ? globalThis.Number(object.discount) : 0,
      payment_success: isSet(object.payment_success) ? globalThis.Boolean(object.payment_success) : false,
      is_non_instant: isSet(object.is_non_instant) ? globalThis.Boolean(object.is_non_instant) : false,
      is_available: isSet(object.is_available) ? globalThis.Boolean(object.is_available) : false,
      price_off: isSet(object.price_off) ? globalThis.Number(object.price_off) : 0,
      discount_percent: isSet(object.discount_percent) ? globalThis.Number(object.discount_percent) : 0,
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      available_hotels_id: globalThis.Array.isArray(object?.available_hotels_id)
        ? object.available_hotels_id.map((e: any) => globalThis.Number(e))
        : [],
      available_rooms_id: globalThis.Array.isArray(object?.available_rooms_id)
        ? object.available_rooms_id.map((e: any) => globalThis.Number(e))
        : [],
      eligible_payment_gateways: globalThis.Array.isArray(object?.eligible_payment_gateways)
        ? object.eligible_payment_gateways.map((e: any) => globalThis.String(e))
        : [],
      sent_date: isSet(object.sent_date) ? fromJsonTimestamp(object.sent_date) : undefined,
      user_phone_number: isSet(object.user_phone_number) ? globalThis.String(object.user_phone_number) : "",
      submit_date: isSet(object.submit_date) ? fromJsonTimestamp(object.submit_date) : undefined,
      count_of_photos: isSet(object.count_of_photos) ? globalThis.Number(object.count_of_photos) : 0,
      comment_entered: isSet(object.comment_entered) ? globalThis.Boolean(object.comment_entered) : false,
      photo_included: isSet(object.photo_included) ? globalThis.Boolean(object.photo_included) : false,
      usefulness_count: isSet(object.usefulness_count) ? globalThis.Number(object.usefulness_count) : 0,
      review_id: isSet(object.review_id) ? globalThis.Number(object.review_id) : 0,
      category_name: isSet(object.category_name) ? globalThis.String(object.category_name) : "",
      video_title: isSet(object.video_title) ? globalThis.String(object.video_title) : "",
      video_duration: isSet(object.video_duration) ? globalThis.Number(object.video_duration) : 0,
      video_watched_percentage: isSet(object.video_watched_percentage)
        ? globalThis.Number(object.video_watched_percentage)
        : 0,
      video_watched_duration: isSet(object.video_watched_duration)
        ? globalThis.Number(object.video_watched_duration)
        : 0,
      video_watched: isSet(object.video_watched) ? globalThis.Number(object.video_watched) : 0,
      number_of_video_interactions: isSet(object.number_of_video_interactions)
        ? globalThis.Number(object.number_of_video_interactions)
        : 0,
      total_interactions: isSet(object.total_interactions) ? globalThis.Number(object.total_interactions) : 0,
      number_of_interactions: isSet(object.number_of_interactions)
        ? globalThis.Number(object.number_of_interactions)
        : 0,
      count_of_videos: isSet(object.count_of_videos) ? globalThis.Number(object.count_of_videos) : 0,
      count_of_clicks_on_video: isSet(object.count_of_clicks_on_video)
        ? globalThis.Number(object.count_of_clicks_on_video)
        : 0,
      fully_watched: isSet(object.fully_watched) ? globalThis.Boolean(object.fully_watched) : false,
      cta_type: isSet(object.cta_type) ? globalThis.String(object.cta_type) : "",
      redirected_link: isSet(object.redirected_link) ? globalThis.String(object.redirected_link) : "",
      last_minute_loaded: isSet(object.last_minute_loaded) ? globalThis.Number(object.last_minute_loaded) : 0,
      count_of_last_minute_cards: isSet(object.count_of_last_minute_cards)
        ? globalThis.Number(object.count_of_last_minute_cards)
        : 0,
      last_minute_card_clicked: isSet(object.last_minute_card_clicked)
        ? globalThis.Number(object.last_minute_card_clicked)
        : 0,
      blue_box_loaded: isSet(object.blue_box_loaded) ? globalThis.Number(object.blue_box_loaded) : 0,
      blue_box_card_clicked: isSet(object.blue_box_card_clicked) ? globalThis.Number(object.blue_box_card_clicked) : 0,
      from_last_minute: isSet(object.from_last_minute) ? globalThis.Number(object.from_last_minute) : 0,
      from_blue_box: isSet(object.from_blue_box) ? globalThis.Number(object.from_blue_box) : 0,
      count_of_blue_box_cards: isSet(object.count_of_blue_box_cards)
        ? globalThis.Number(object.count_of_blue_box_cards)
        : 0,
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      search_source: isSet(object.search_source) ? searchSourceFromJSON(object.search_source) : SearchSource.search_box,
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      basket_price: isSet(object.basket_price) ? globalThis.Number(object.basket_price) : 0,
      ycard_balance: isSet(object.ycard_balance) ? globalThis.Number(object.ycard_balance) : 0,
      penny_balance: isSet(object.penny_balance) ? globalThis.Number(object.penny_balance) : 0,
      user_location: isSet(object.user_location) ? Location.fromJSON(object.user_location) : undefined,
      initial_zoom_level: isSet(object.initial_zoom_level) ? globalThis.Number(object.initial_zoom_level) : 0,
      listings_count: isSet(object.listings_count) ? globalThis.Number(object.listings_count) : 0,
      viewport_change_type: isSet(object.viewport_change_type) ? globalThis.String(object.viewport_change_type) : "",
      new_center_coords: isSet(object.new_center_coords) ? Location.fromJSON(object.new_center_coords) : undefined,
      visible_listings_count: isSet(object.visible_listings_count)
        ? globalThis.Number(object.visible_listings_count)
        : 0,
      accommodation_id: isSet(object.accommodation_id) ? globalThis.Number(object.accommodation_id) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      click_area: isSet(object.click_area) ? globalThis.String(object.click_area) : "",
      stay_duration_days: isSet(object.stay_duration_days) ? globalThis.Number(object.stay_duration_days) : 0,
      removed_filter_name: isSet(object.removed_filter_name) ? globalThis.String(object.removed_filter_name) : "",
      current_map_center: isSet(object.current_map_center) ? Location.fromJSON(object.current_map_center) : undefined,
      current_zoom_level: isSet(object.current_zoom_level) ? globalThis.Number(object.current_zoom_level) : 0,
      new_view_state: isSet(object.new_view_state) ? globalThis.String(object.new_view_state) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: DomHotel): unknown {
    const obj: any = {};
    if (message.date_from !== "") {
      obj.date_from = message.date_from;
    }
    if (message.date_to !== "") {
      obj.date_to = message.date_to;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.city_id !== 0) {
      obj.city_id = Math.round(message.city_id);
    }
    if (message.hotel !== "") {
      obj.hotel = message.hotel;
    }
    if (message.hotel_id !== 0) {
      obj.hotel_id = Math.round(message.hotel_id);
    }
    if (message.ranking !== 0) {
      obj.ranking = Math.round(message.ranking);
    }
    if (message.rooms?.length) {
      obj.rooms = message.rooms.map((e) => RoomDom.toJSON(e));
    }
    if (message.final_price !== 0) {
      obj.final_price = Math.round(message.final_price);
    }
    if (message.book_price !== 0) {
      obj.book_price = Math.round(message.book_price);
    }
    if (message.shop_random_id !== "") {
      obj.shop_random_id = message.shop_random_id;
    }
    if (message.booking_id !== "") {
      obj.booking_id = message.booking_id;
    }
    if (message.price_engine_rules?.length) {
      obj.price_engine = message.price_engine_rules.map((e) => PriceEngineRules.toJSON(e));
    }
    if (message.book_type !== "") {
      obj.book_type = message.book_type;
    }
    if (message.payment_gateway !== "") {
      obj.payment_gateway = message.payment_gateway;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.discount_code !== "") {
      obj.discount_code = message.discount_code;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.discount !== 0) {
      obj.discount = Math.round(message.discount);
    }
    if (message.payment_success !== false) {
      obj.payment_success = message.payment_success;
    }
    if (message.is_non_instant !== false) {
      obj.is_non_instant = message.is_non_instant;
    }
    if (message.is_available !== false) {
      obj.is_available = message.is_available;
    }
    if (message.price_off !== 0) {
      obj.price_off = Math.round(message.price_off);
    }
    if (message.discount_percent !== 0) {
      obj.discount_percent = Math.round(message.discount_percent);
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.available_hotels_id?.length) {
      obj.available_hotels_id = message.available_hotels_id.map((e) => Math.round(e));
    }
    if (message.available_rooms_id?.length) {
      obj.available_rooms_id = message.available_rooms_id.map((e) => Math.round(e));
    }
    if (message.eligible_payment_gateways?.length) {
      obj.eligible_payment_gateways = message.eligible_payment_gateways;
    }
    if (message.sent_date !== undefined) {
      obj.sent_date = message.sent_date.toISOString();
    }
    if (message.user_phone_number !== "") {
      obj.user_phone_number = message.user_phone_number;
    }
    if (message.submit_date !== undefined) {
      obj.submit_date = message.submit_date.toISOString();
    }
    if (message.count_of_photos !== 0) {
      obj.count_of_photos = Math.round(message.count_of_photos);
    }
    if (message.comment_entered !== false) {
      obj.comment_entered = message.comment_entered;
    }
    if (message.photo_included !== false) {
      obj.photo_included = message.photo_included;
    }
    if (message.usefulness_count !== 0) {
      obj.usefulness_count = Math.round(message.usefulness_count);
    }
    if (message.review_id !== 0) {
      obj.review_id = Math.round(message.review_id);
    }
    if (message.category_name !== "") {
      obj.category_name = message.category_name;
    }
    if (message.video_title !== "") {
      obj.video_title = message.video_title;
    }
    if (message.video_duration !== 0) {
      obj.video_duration = Math.round(message.video_duration);
    }
    if (message.video_watched_percentage !== 0) {
      obj.video_watched_percentage = Math.round(message.video_watched_percentage);
    }
    if (message.video_watched_duration !== 0) {
      obj.video_watched_duration = Math.round(message.video_watched_duration);
    }
    if (message.video_watched !== 0) {
      obj.video_watched = Math.round(message.video_watched);
    }
    if (message.number_of_video_interactions !== 0) {
      obj.number_of_video_interactions = Math.round(message.number_of_video_interactions);
    }
    if (message.total_interactions !== 0) {
      obj.total_interactions = Math.round(message.total_interactions);
    }
    if (message.number_of_interactions !== 0) {
      obj.number_of_interactions = Math.round(message.number_of_interactions);
    }
    if (message.count_of_videos !== 0) {
      obj.count_of_videos = Math.round(message.count_of_videos);
    }
    if (message.count_of_clicks_on_video !== 0) {
      obj.count_of_clicks_on_video = Math.round(message.count_of_clicks_on_video);
    }
    if (message.fully_watched !== false) {
      obj.fully_watched = message.fully_watched;
    }
    if (message.cta_type !== "") {
      obj.cta_type = message.cta_type;
    }
    if (message.redirected_link !== "") {
      obj.redirected_link = message.redirected_link;
    }
    if (message.last_minute_loaded !== 0) {
      obj.last_minute_loaded = Math.round(message.last_minute_loaded);
    }
    if (message.count_of_last_minute_cards !== 0) {
      obj.count_of_last_minute_cards = Math.round(message.count_of_last_minute_cards);
    }
    if (message.last_minute_card_clicked !== 0) {
      obj.last_minute_card_clicked = Math.round(message.last_minute_card_clicked);
    }
    if (message.blue_box_loaded !== 0) {
      obj.blue_box_loaded = Math.round(message.blue_box_loaded);
    }
    if (message.blue_box_card_clicked !== 0) {
      obj.blue_box_card_clicked = Math.round(message.blue_box_card_clicked);
    }
    if (message.from_last_minute !== 0) {
      obj.from_last_minute = Math.round(message.from_last_minute);
    }
    if (message.from_blue_box !== 0) {
      obj.from_blue_box = Math.round(message.from_blue_box);
    }
    if (message.count_of_blue_box_cards !== 0) {
      obj.count_of_blue_box_cards = Math.round(message.count_of_blue_box_cards);
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.search_source !== SearchSource.search_box) {
      obj.search_source = searchSourceToJSON(message.search_source);
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.basket_price !== 0) {
      obj.basket_price = Math.round(message.basket_price);
    }
    if (message.ycard_balance !== 0) {
      obj.ycard_balance = Math.round(message.ycard_balance);
    }
    if (message.penny_balance !== 0) {
      obj.penny_balance = Math.round(message.penny_balance);
    }
    if (message.user_location !== undefined) {
      obj.user_location = Location.toJSON(message.user_location);
    }
    if (message.initial_zoom_level !== 0) {
      obj.initial_zoom_level = Math.round(message.initial_zoom_level);
    }
    if (message.listings_count !== 0) {
      obj.listings_count = Math.round(message.listings_count);
    }
    if (message.viewport_change_type !== "") {
      obj.viewport_change_type = message.viewport_change_type;
    }
    if (message.new_center_coords !== undefined) {
      obj.new_center_coords = Location.toJSON(message.new_center_coords);
    }
    if (message.visible_listings_count !== 0) {
      obj.visible_listings_count = Math.round(message.visible_listings_count);
    }
    if (message.accommodation_id !== 0) {
      obj.accommodation_id = Math.round(message.accommodation_id);
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.click_area !== "") {
      obj.click_area = message.click_area;
    }
    if (message.stay_duration_days !== 0) {
      obj.stay_duration_days = Math.round(message.stay_duration_days);
    }
    if (message.removed_filter_name !== "") {
      obj.removed_filter_name = message.removed_filter_name;
    }
    if (message.current_map_center !== undefined) {
      obj.current_map_center = Location.toJSON(message.current_map_center);
    }
    if (message.current_zoom_level !== 0) {
      obj.current_zoom_level = Math.round(message.current_zoom_level);
    }
    if (message.new_view_state !== "") {
      obj.new_view_state = message.new_view_state;
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<DomHotel>): DomHotel {
    return DomHotel.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DomHotel>): DomHotel {
    const message = createBaseDomHotel();
    message.date_from = object.date_from ?? "";
    message.date_to = object.date_to ?? "";
    message.city = object.city ?? "";
    message.city_id = object.city_id ?? 0;
    message.hotel = object.hotel ?? "";
    message.hotel_id = object.hotel_id ?? 0;
    message.ranking = object.ranking ?? 0;
    message.rooms = object.rooms?.map((e) => RoomDom.fromPartial(e)) || [];
    message.final_price = object.final_price ?? 0;
    message.book_price = object.book_price ?? 0;
    message.shop_random_id = object.shop_random_id ?? "";
    message.booking_id = object.booking_id ?? "";
    message.price_engine_rules = object.price_engine_rules?.map((e) => PriceEngineRules.fromPartial(e)) || [];
    message.book_type = object.book_type ?? "";
    message.payment_gateway = object.payment_gateway ?? "";
    message.amount = object.amount ?? 0;
    message.discount_code = object.discount_code ?? "";
    message.error = object.error ?? "";
    message.discount = object.discount ?? 0;
    message.payment_success = object.payment_success ?? false;
    message.is_non_instant = object.is_non_instant ?? false;
    message.is_available = object.is_available ?? false;
    message.price_off = object.price_off ?? 0;
    message.discount_percent = object.discount_percent ?? 0;
    message.page = object.page ?? 0;
    message.available_hotels_id = object.available_hotels_id?.map((e) => e) || [];
    message.available_rooms_id = object.available_rooms_id?.map((e) => e) || [];
    message.eligible_payment_gateways = object.eligible_payment_gateways?.map((e) => e) || [];
    message.sent_date = object.sent_date ?? undefined;
    message.user_phone_number = object.user_phone_number ?? "";
    message.submit_date = object.submit_date ?? undefined;
    message.count_of_photos = object.count_of_photos ?? 0;
    message.comment_entered = object.comment_entered ?? false;
    message.photo_included = object.photo_included ?? false;
    message.usefulness_count = object.usefulness_count ?? 0;
    message.review_id = object.review_id ?? 0;
    message.category_name = object.category_name ?? "";
    message.video_title = object.video_title ?? "";
    message.video_duration = object.video_duration ?? 0;
    message.video_watched_percentage = object.video_watched_percentage ?? 0;
    message.video_watched_duration = object.video_watched_duration ?? 0;
    message.video_watched = object.video_watched ?? 0;
    message.number_of_video_interactions = object.number_of_video_interactions ?? 0;
    message.total_interactions = object.total_interactions ?? 0;
    message.number_of_interactions = object.number_of_interactions ?? 0;
    message.count_of_videos = object.count_of_videos ?? 0;
    message.count_of_clicks_on_video = object.count_of_clicks_on_video ?? 0;
    message.fully_watched = object.fully_watched ?? false;
    message.cta_type = object.cta_type ?? "";
    message.redirected_link = object.redirected_link ?? "";
    message.last_minute_loaded = object.last_minute_loaded ?? 0;
    message.count_of_last_minute_cards = object.count_of_last_minute_cards ?? 0;
    message.last_minute_card_clicked = object.last_minute_card_clicked ?? 0;
    message.blue_box_loaded = object.blue_box_loaded ?? 0;
    message.blue_box_card_clicked = object.blue_box_card_clicked ?? 0;
    message.from_last_minute = object.from_last_minute ?? 0;
    message.from_blue_box = object.from_blue_box ?? 0;
    message.count_of_blue_box_cards = object.count_of_blue_box_cards ?? 0;
    message.gateway = object.gateway ?? "";
    message.search_source = object.search_source ?? SearchSource.search_box;
    message.timestamp = object.timestamp ?? undefined;
    message.basket_price = object.basket_price ?? 0;
    message.ycard_balance = object.ycard_balance ?? 0;
    message.penny_balance = object.penny_balance ?? 0;
    message.user_location = (object.user_location !== undefined && object.user_location !== null)
      ? Location.fromPartial(object.user_location)
      : undefined;
    message.initial_zoom_level = object.initial_zoom_level ?? 0;
    message.listings_count = object.listings_count ?? 0;
    message.viewport_change_type = object.viewport_change_type ?? "";
    message.new_center_coords = (object.new_center_coords !== undefined && object.new_center_coords !== null)
      ? Location.fromPartial(object.new_center_coords)
      : undefined;
    message.visible_listings_count = object.visible_listings_count ?? 0;
    message.accommodation_id = object.accommodation_id ?? 0;
    message.position = object.position ?? 0;
    message.click_area = object.click_area ?? "";
    message.stay_duration_days = object.stay_duration_days ?? 0;
    message.removed_filter_name = object.removed_filter_name ?? "";
    message.current_map_center = (object.current_map_center !== undefined && object.current_map_center !== null)
      ? Location.fromPartial(object.current_map_center)
      : undefined;
    message.current_zoom_level = object.current_zoom_level ?? 0;
    message.new_view_state = object.new_view_state ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
